import clsx from "clsx";
import React, { useContext } from "react";
import { twMerge } from "tailwind-merge";

import PrincipalBanner from "../../contents/PrincipalBanner";
import { I18nContext } from "../../i18n/useI18n";

const entrepreneurshipContent = "pages.public-engagement.entrepreneurship";

const EntrepreneurshipPage = () => {
  const { t } = useContext(I18nContext);

  return (
    <main className="mx-auto my-0 max-w-7xl">
      <PrincipalBanner
     
        classNames={twMerge(clsx("min-h-[200px] md:min-h-[400px]"))}
      >
        <img
          className="absolute w-full min-h-full object-cover"
          src="https://static.igem.wiki/teams/5058/novas-imagens/banner-novo-empreendedorismo.webp"
          alt="banner education"
        />
        <h1 className="invisible">{t(`${entrepreneurshipContent}.title`)}</h1>
      </PrincipalBanner>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.why.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.why.text`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.what.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.what.text`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.how.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.how.text`)}</p>
      </section>
      <p className="text-center">
        <img
          className="inline-block w-30 min-h-50 object-cover"
          src="https://static.igem.wiki/teams/5058/dna-et.svg"
          alt="banner education"
        />
      </p>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.mission.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.mission.text`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.vision.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.vision.text`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.values.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.values.description`)}</p>
        <article>
          
          <ul>
            <li>
              <p>{t(`${entrepreneurshipContent}.values.items.0.value`)}</p>
            </li>
            <li>
              <p>
                {t(`${entrepreneurshipContent}.values.items.0.description`)}
              </p>
            </li>
          </ul>
        </article>
        <article>
       
          <ul>
            <li>
              <p>{t(`${entrepreneurshipContent}.values.items.1.value`)}</p>
            </li>
            <li>
              <p>
                {t(`${entrepreneurshipContent}.values.items.1.description`)}
              </p>
            </li>
          </ul>
        </article>
        <article>
        
          <ul>
            <li>
              <p>{t(`${entrepreneurshipContent}.values.items.2.value`)}</p>
            </li>
            <li>
              <p>
                {t(`${entrepreneurshipContent}.values.items.2.description`)}
              </p>
            </li>
          </ul>
        </article>
        <article>
        
          <ul>
            <li>
              <p>{t(`${entrepreneurshipContent}.values.items.3.value`)}</p>
            </li>
            <li>
              <p>
                {t(`${entrepreneurshipContent}.values.items.3.description`)}
              </p>
            </li>
          </ul>
      
        </article>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.unmetNeeds.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.unmetNeeds.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.unmetNeeds.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.unmetNeeds.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.unmetNeeds.description4`)}</p>
   
        {/* <article>
          <p> 
            {t(`${entrepreneurshipContent}.unmetNeeds.statistics.otherStates`)}
          </p>
          <ul></ul>
        </article> */}
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.climateEffects.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.climateEffects.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.climateEffects.description2`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.opportunityPoints.title`)}</h2>
        <article>
         
          <ul>
            <li>
              <label>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.productivity.title`
                )}
              </label>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.productivity.description`
                )}
              </p>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.productivity.description2`
                )}
              </p>
            </li>
          </ul>
        </article>
        <article>
          
          <ul>
            <li>
              <label>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.stressTolerance.title`
                )}
              </label>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.stressTolerance.description`
                )}
              </p>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.stressTolerance.description2`
                )}
              </p>
            </li>
          </ul>
          
        </article>
        <article>
        
          <ul>
            <li>
              <label>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.sustainability.title`
                )}
              </label>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.sustainability.description`
                )}
              </p>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.sustainability.description2`
                )}
              </p>
            </li>
          </ul>
         
        </article>
        <article>
        
          <ul>
            <li>
              <label>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.costEffectiveness.title`
                )}
              </label>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.costEffectiveness.description`
                )}
              </p>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.costEffectiveness.description2`
                )}
              </p>
            </li>
          </ul>
        
        </article>
        <article>
          <ul>
            <li>
              <label>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.adaptation.title`
                )}
              </label>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.adaptation.description`
                )}
              </p>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.adaptation.description2`
                )}
              </p>
            </li>
          </ul>
       
        </article>
        <article>
          
          <ul>
            <li>
              <label>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.innovation.title`
                )}
              </label>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.innovation.description`
                )}
              </p>
            </li>
            <li>
              <p>
                {t(
                  `${entrepreneurshipContent}.opportunityPoints.categories.innovation.description2`
                )}
              </p>
            </li>
          </ul>
         
        </article>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.empathyMap.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.empathyMap.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.empathyMap.description2`)}</p>
      <img className="ml-48" src="https://static.igem.wiki/teams/5058/entrep5.svg" alt="" />
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.Technology.title`)}</h2>
        <img className="ml-48 w-[70%] h-92" src="https://static.igem.wiki/teams/5058/entrep6.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.Technology.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.Technology.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.Technology.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.Technology.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.Technology.description5`)}</p>
        <p>{t(`${entrepreneurshipContent}.Technology.description6`)}</p>
        <p>{t(`${entrepreneurshipContent}.Technology.description7`)}</p>
        <p>{t(`${entrepreneurshipContent}.Technology.description8`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.MarketAnalysis.title`)}</h2>
        <img className="h-48" src="https://static.igem.wiki/teams/5058/marketanalysis.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.MarketAnalysis.description`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.MarketStrategy.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.MarketStrategy.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.MarketStrategy.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.MarketStrategy.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.MarketStrategy.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.MarketStrategy.description5`)}</p>
        <img className="ml-48 h-48" src="https://static.igem.wiki/teams/5058/cagr.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.MarketStrategy.description6`)}</p>
        <img className="ml-48 h-24" src="https://static.igem.wiki/teams/5058/n.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.MarketStrategy.description7`)}</p>
        <p>{t(`${entrepreneurshipContent}.MarketStrategy.description8`)}</p>
        <p>{t(`${entrepreneurshipContent}.MarketStrategy.description9`)}</p>
        <p>{t(`${entrepreneurshipContent}.MarketStrategy.description10`)}</p>
        <p>{t(`${entrepreneurshipContent}.MarketStrategy.description11`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.BeachheadStrategy.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.BeachheadStrategy.description`)}</p>
        <img src="https://static.igem.wiki/teams/5058/esquemaentrep.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.BeachheadStrategy.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.BeachheadStrategy.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.BeachheadStrategy.description4`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.ValueProposition.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.ValueProposition.description`)}</p>
        <img src="https://static.igem.wiki/teams/5058/tabela-1-empreendedorismo.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.ValueProposition.description2`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.ValueChain.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.ValueChain.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.ValueChain.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.ValueChain.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.ValueChain.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.ValueChain.description5`)}</p>
        <p>{t(`${entrepreneurshipContent}.ValueChain.description6`)}</p>
        <p>{t(`${entrepreneurshipContent}.ValueChain.description7`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.PrimaryCustomers.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.PrimaryCustomers.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.PrimaryCustomers.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.PrimaryCustomers.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.PrimaryCustomers.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.PrimaryCustomers.description5`)}</p>
        <p>{t(`${entrepreneurshipContent}.PrimaryCustomers.description6`)}</p>
        <p>{t(`${entrepreneurshipContent}.PrimaryCustomers.description7`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.PESTELAnalysis.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.PESTELAnalysis.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.PESTELAnalysis.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.PESTELAnalysis.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.PESTELAnalysis.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.PESTELAnalysis.description5`)}</p>
        <p>{t(`${entrepreneurshipContent}.PESTELAnalysis.description6`)}</p>
        <p>{t(`${entrepreneurshipContent}.PESTELAnalysis.description7`)}</p>
        <p>{t(`${entrepreneurshipContent}.PESTELAnalysis.description8`)}</p>
        <img src="https://static.igem.wiki/teams/5058/pestel.svg" alt="" />
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.CompetitorAnalysis.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.CompetitorAnalysis.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.CompetitorAnalysis.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.CompetitorAnalysis.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.CompetitorAnalysis.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.CompetitorAnalysis.description5`)}</p>
        <p>{t(`${entrepreneurshipContent}.CompetitorAnalysis.description6`)}</p>
        <p>{t(`${entrepreneurshipContent}.CompetitorAnalysis.description7`)}</p>
        <p>{t(`${entrepreneurshipContent}.CompetitorAnalysis.description8`)}</p>
        <p>{t(`${entrepreneurshipContent}.CompetitorAnalysis.description9`)}</p>
        <p>
          {t(`${entrepreneurshipContent}.CompetitorAnalysis.description10`)}
        </p>
        <p>
          {t(`${entrepreneurshipContent}.CompetitorAnalysis.description11`)}
        </p>
        <img src="https://static.igem.wiki/teams/5058/competitor-criterion-matrix.svg" alt="" />
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.SWOTMatrix.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.SWOTMatrix.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.SWOTMatrix.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.SWOTMatrix.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.SWOTMatrix.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.SWOTMatrix.description5`)}</p>
        <img src="https://static.igem.wiki/teams/5058/swot.svg" alt="" />
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.ProtectionStrategies.title`)}</h2>
        <p>
          {t(`${entrepreneurshipContent}.ProtectionStrategies.description`)}
        </p>
        <p>
          {t(`${entrepreneurshipContent}.ProtectionStrategies.description2`)}
        </p>
        <p>
          {t(`${entrepreneurshipContent}.ProtectionStrategies.description3`)}
        </p>
        <p>
          {t(`${entrepreneurshipContent}.ProtectionStrategies.description4`)}
        </p>
        <p>
          {t(`${entrepreneurshipContent}.ProtectionStrategies.description5`)}
        </p>
        <p>
          {t(`${entrepreneurshipContent}.ProtectionStrategies.description6`)}
        </p>
        <p>
          {t(`${entrepreneurshipContent}.ProtectionStrategies.description7`)}
        </p>
        <p>
          {t(`${entrepreneurshipContent}.ProtectionStrategies.description8`)}
        </p>
        <img className="mt-16" src="https://static.igem.wiki/teams/5058/protection-strategies.svg" alt="" />
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.Finances.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.Finances.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.Finances.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.Finances.description3`)}</p>
        <h3>YPD Medium Price Calculation (Sigma Products)</h3>
        <img src="https://static.igem.wiki/teams/5058/finance-tabela-1.svg" alt="" />
        <h3>Sugarcane Juice Price Calculation</h3>
        <img src="https://static.igem.wiki/teams/5058/finance-tabela-2.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.Finances.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.Finances.description5`)}</p>
        <p>{t(`${entrepreneurshipContent}.Finances.description6`)}</p>
        <p>{t(`${entrepreneurshipContent}.Finances.description7`)}</p>
        <p>{t(`${entrepreneurshipContent}.Finances.description8`)}</p>
        <p>{t(`${entrepreneurshipContent}.Finances.description9`)}</p>
        <p>{t(`${entrepreneurshipContent}.Finances.description10`)}</p>
        <p>{t(`${entrepreneurshipContent}.Finances.description11`)}</p>
        <p>{t(`${entrepreneurshipContent}.Finances.description12`)}</p>
        <img src="https://static.igem.wiki/teams/5058/finance-tabela-3.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.Finances.description13`)}</p>
        <img src="https://static.igem.wiki/teams/5058/finance-tabela-4.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.Finances.description14`)}</p>
        <p>{t(`${entrepreneurshipContent}.Finances.description15`)}</p>
        <img src="https://static.igem.wiki/teams/5058/finance-tabela-5.svg" alt="" />
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.ProductValuation.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.ProductValuation.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.ProductValuation.description2`)}</p>
        <img src="https://static.igem.wiki/teams/5058/finance-tabela-6.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.ProductValuation.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.ProductValuation.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.ProductValuation.description5`)}</p>
        <p>{t(`${entrepreneurshipContent}.ProductValuation.description6`)}</p>
        <p>{t(`${entrepreneurshipContent}.ProductValuation.description7`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.RiskAssessment.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.RiskAssessment.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.RiskAssessment.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.RiskAssessment.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.RiskAssessment.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.RiskAssessment.description5`)}</p>
        <p>{t(`${entrepreneurshipContent}.RiskAssessment.description6`)}</p>
        <p>{t(`${entrepreneurshipContent}.RiskAssessment.description7`)}</p>
        <p>{t(`${entrepreneurshipContent}.RiskAssessment.description8`)}</p>
        <p>{t(`${entrepreneurshipContent}.RiskAssessment.description9`)}</p>
        <p>{t(`${entrepreneurshipContent}.RiskAssessment.description10`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.MarketingStrategy.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.MarketingStrategy.description`)}</p>
        <img src="https://static.igem.wiki/teams/5058/marketing-strategy.svg" alt="" />
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.LongTermImpacts.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description2`)}</p>
        <img src="https://static.igem.wiki/teams/5058/longterm-impacts-zero-hunger.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description5`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description6`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description7`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description8`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description9`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description10`)}</p>
        <img src="https://static.igem.wiki/teams/5058/long-term-impacts-industries.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description11`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description12`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description13`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description14`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description15`)}</p>
        <img src="https://static.igem.wiki/teams/5058/long-term-impacts-responsible.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description16`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description17`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description18`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description19`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description20`)}</p>
     <img src="https://static.igem.wiki/teams/5058/long-term-impacts-life.svg" alt="" />
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description21`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description22`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description23`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description24`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description25`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description26`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description27`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description28`)}</p>
        <p>{t(`${entrepreneurshipContent}.LongTermImpacts.description29`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${entrepreneurshipContent}.Bibliography.title`)}</h2>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description2`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description3`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description4`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description5`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description6`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description7`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description8`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description9`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description10`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description11`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description12`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description13`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description14`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description15`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description16`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description17`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description18`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description19`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description20`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description21`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description22`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description23`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description24`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description25`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description26`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description27`)}</p>
        <p>{t(`${entrepreneurshipContent}.Bibliography.description28`)}</p>
      </section>
    </main>
  );
};

export default EntrepreneurshipPage;
